<div class="row">
  <div class="col-12 col-lg-8">
    <div class="d-flex d-flex-row">
      <div>
        <ejs-grid #grid
                  class="grid-with-toolbar"
                  width="100%"
                  rowHeight="38"
                  [allowSelection]="true"
                  [dataSource]="this.priceFormGroup.controls.tieredPrices.value"
                  [editSettings]="editSettings"
                  (actionBegin)="actionBegin($event)"
                  (actionComplete)="actionComplete($event)">
          <ng-template #toolbarTemplate let-data>
            <ejs-toolbar>
              <e-items>
                <e-item [text]="'i18n.domain.administration.tariff-details.price-tab.add' | translate" prefixIcon='e-icons icon-add' (click)="onAdd()"></e-item>
              </e-items>
            </ejs-toolbar>
          </ng-template>
          <e-columns>
            <e-column field="id"
                      [visible]="false"
                      isPrimaryKey="true"></e-column>
            <e-column field="evaluationRelayIndex"
                      headerText="{{'i18n.domain.administration.tariff-details.price-tab.tier' | translate}}">
              <ng-template #template let-data>
                {{data.evaluationRelayIndex + 1}}
              </ng-template>
            </e-column>
            <e-column field="amountOfMinutes"
                      headerText="{{'i18n.domain.administration.tariff-details.price-tab.amount-of-minutes' | translate}}"
                      clipMode="EllipsisWithTooltip"
                      editType="numericedit">
            </e-column>
            <e-column field="pricePerHour"
                      headerText="{{'i18n.domain.administration.tariff-details.price-tab.price-hour' | translate}}"
                      clipMode="EllipsisWithTooltip"
                      editType="numericedit">
              <ng-template #template let-data>
                {{data.pricePerHour | number : '1.2-2'}}
              </ng-template>
            </e-column>
            <e-column field="minStepInMinutes"
                      headerText="{{'i18n.domain.administration.tariff-details.price-tab.minStepInMinutes' | translate}}"
                      clipMode="EllipsisWithTooltip">
            </e-column>
            <e-column field="tierRange"
                      headerText="{{'i18n.domain.administration.tariff-details.price-tab.tier-range' | translate}}">
            </e-column>
            <e-column headerText=""
                      [commands]="gridCommands"
                      width="100px">
            </e-column>
          </e-columns>
          <ng-template #editSettingsTemplate let-data>
            <app-tiered-price-form [tieredPriceForm]="gridEditForm"></app-tiered-price-form>
          </ng-template>
        </ejs-grid>
        <table class="total-table">
          <tr>
            <td [ngClass]="{'warning': isTotalNotEqualToMaxDuration}">{{'i18n.domain.administration.tariff-details.price-tab.total-tiered' | translate}}:</td>
            <td class="text-end" [ngClass]="{'warning': isTotalNotEqualToMaxDuration}">{{totalTiered}} min</td>
          </tr>
        @if(maxParkingDuration) {
          <tr>
            <td>{{'i18n.domain.administration.tariff-details.general-tab.max-parking-duration' | translate}}:</td>
            <td class="text-end">{{maxParkingDuration}} min</td>
          </tr>
        }
        </table>
      </div>
      <div class="button-col">
        <div class="switchButtonGroup">
          <div class="d-flex justify-content-center">
            <button type="button"
                    class="btn btn-secondary switchButton"
                    (click)="onUp()"
                    [disabled]="!canMoveUp">
              <div class="e-icons icon-arrow--up"></div>
            </button>
          </div>
          <div class="d-flex justify-content-center">
            <button type="button"
                    class="btn btn-secondary switchButton"
                    (click)="onDown()"
                    [disabled]="!canMoveDown">
              <div class="e-icons icon-arrow--down"></div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-4 example">
    {{'i18n.domain.administration.tariff-details.price-tab.example' | translate}}:
    <table>
      <tr class="header-row">
        <th class="col-1">{{'i18n.domain.administration.tariff-details.price-tab.tier' | translate}}</th>
        <th class="col-2">{{'i18n.domain.administration.tariff-details.price-tab.amount-of-minutes' | translate}}</th>
        <th class="col-2">{{'i18n.domain.administration.tariff-details.price-tab.minStepInMinutes' | translate}}</th>
        <th>{{'i18n.domain.administration.tariff-details.price-tab.price' | translate}}</th>
      </tr>
      <tr><td>1</td><td>15</td><td></td><td>0.00</td></tr>
      <tr><td>2</td><td>45</td><td>30</td><td>0.50</td></tr>
      <tr><td>3</td><td>180</td><td>60</td><td>2.00</td></tr>
    </table>
    <table>
      <tr class="header-row">
        <th class="col-merged">{{'i18n.domain.administration.tariff-details.price-tab.parking-duration' | translate}}</th>
        <th>{{'i18n.domain.administration.tariff-details.price-tab.costs' | translate}}</th>
      </tr>
      <tr><td>13</td><td>0.00</td></tr>
      <tr><td>16</td><td>0.25</td></tr>
      <tr><td>45</td><td>0.25</td></tr>
      <tr><td>46</td><td>0.50</td></tr>
      <tr><td>60</td><td>0.50</td></tr>
      <tr><td>61</td><td>2.50</td></tr>
      <tr><td>120</td><td>2.50</td></tr>
      <tr><td>121</td><td>4.50</td></tr>
      <tr><td>180</td><td>4.50</td></tr>
      <tr><td>181</td><td>6.50</td></tr>
    </table>
  </div>
</div>
